<app-ui-button
  [ngClass]="[buttonClass]"
  buttonType="icon-button"
  icon="person"
  (click)="navigateToPerson($event)"
></app-ui-button>
